import React, { useState, useEffect } from 'react';

import ReportsSection from "../components/RegisterAsFarm/ReportDropdown2"
import LanguageSelector from '../components/RegisterAsFarm/LangugageSelector';
import PersonalInfoForm from '../components/RegisterAsFarm/PersonalInfoForm';
import OrganizationForm from '../components/RegisterAsFarm/OrganizationForm';
import IndustrySection from '../components/RegisterAsFarm/IndustrySection';
import ProfingSkils from "../components/RegisterAsFarm/ProfingSkils";
import MembershipSection from "../components/RegisterAsFarm/MembershipSection";
import SectionD from '../components/RegisterAsFarm/SectionD';
import SectionDnew from '../components/RegisterAsFarm/SectionDnew';
import BackgroundInfoSection from '../components/RegisterAsFarm/BackgroundInfoSection';
import LocationPicker from "./LocationPicker";
import { motion, AnimatePresence } from "framer-motion";
import Dropdown1 from '../components/RegisterAsFarm/Dropdown';
import GroupExperience from '../components/RegisterAsFarm/GroupExperience';
import Modal from 'react-modal';
import SaveButtonWithModal from '../components/SaveButtonWithModel';
import { getFirestore, setDoc, doc, getDoc } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword, fetchSignInMethodsForEmail } from "firebase/auth";
import { generateRegistrationNumber } from "../utils/generateRegNumber";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
import { sendRegistrationEmail } from "../utils/sendRegistrationsEmail";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from '../firebase'; // Make sure `firebaseConfig` is exported from your firebase.js
import { signInWithEmailAndPassword } from "firebase/auth";

// Init Firebase singletons
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const dropdownItems = {
  FACILITATOR: [
    "Individual (IN)", "Entrepreneur (EN)", "Learners (LN)", "Moderator (MO)", "Facilitator (FA)", "Assessor (AS)", "Evaluator (EV)", "Training provider (TR)", "Cooperative (CO)", "Community (CM)", "EIA"

  ],
  PURPOSE: [
    "Funding", "Training", "Resourcing", "Market", "M&E", "Assessment", "Evaluations", "Impact"

  ],

};

const initialReportSelections = {
  COUNTRY: "SOUTH AFRICA",
  REGION: "Eastern Cape",
  MUNICIPALITY: "Johannesburg",
  TYPE: "Learners",
  "VALUE CHAIN": "Maize",
  PROJECT: "ABATTOIR",
};

const Dropdown = ({ label, items, type, isProjectDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(items[0]);
  const [selectedCircles, setSelectedCircles] = useState({});

  const toggleCircle = (item) => {
    setSelectedCircles((prev) => ({
      ...prev,
      [item]: !prev[item],
    }));
  };

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);
    if (typeof onChange === "function") {
      onChange(type, item);
      // Show in console exactly when user selects:
      console.log(`Selected ${type}:`, item);
    }
  };

  return (
    <div className="flex flex-col w-full relative">
      {/* Button */}
      <div className="flex relative z-20 w-fit">
        <button
          onClick={() => {
            if (isProjectDropdown && selected?.toLowerCase() === "funding") {
              window.location.href = "/funding";
            } else {
              setIsOpen((prev) => !prev);
            }
          }}
          className={`xl:w-[168px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
        >
          <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px]">
            {selected}
          </span>
        </button>
        <div
          className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#F38323] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-[10px] md:w-6 md:h-[24px]"
          />
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 z-50 md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
          >
            <li className="flex items-center justify-between px-2 py-1 mb-2">
              <span className="text-[6px] md:text-[20px] font-semibold">
                Registration - Type of users
              </span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                alt="icon"
                className="md:w-[30px] md:h-[30px] h-[7px] w-[7px]"
              />
            </li>
            {items.map((item, index) => (
              <li
                key={index}
                className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${selected === item ? 'bg-[#E7EBEB]' : ''}`}
                onClick={() => handleSelect(item)}
              >
                <span className="text-black text-[4px] md:text-[18px]">
                  {item}
                </span>
                <div
                  onClick={e => {
                    e.stopPropagation();
                    toggleCircle(item);
                  }}
                  className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${selected === item ? "bg-[#03897B]" : "bg-gray-200"}`}
                ></div>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
      <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
        {isProjectDropdown
          ? "Select PURPOSE"
          : `Select ${type === "FACILITATOR" ? "user type" : label}`}
      </p>
    </div>
  );
};


const languages = [
  'Owned', 'Commonage', 'Community Owned', 'Municipal Land', 'House with a plot',
  'Urban lot', 'Community Food garden allocation', 'No Land Yet',
];
const languages1 = [
  'Leased', 'Community Leased', 'Road side vacant land', 'Village / Local/ Tribunal Authority allocation'

];

const RegisterAsFarm = () => {
  const [selected, setSelected] = useState(null); // <-- initially nothing selected
  const [selected1, setSelected1] = useState(null); // <-- initially nothing selected
  const [selectedBox, setSelectedBox] = useState(null);
  const keys = Object.keys(dropdownItems);
  const handleBoxClick = (index) => {
    setSelectedBox(index);
  };
  const setLandSizes = (newSizes) => {
    console.log("New sizes: ", newSizes);
  };
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false); // Save modal state
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false); // Registration modal state
  // Save Button Click Handler
  const handleSaveClick = () => {
    const dataToSave = {
      formData,
      orgFormData,
      dropdownSelections,
      reportSelections,
      selectedLanguage,
      landType1,
      landType2,
      erfNumber,
      selectedSkills,
      selectedMembership,
      selectedExperience,
      focusSelected,
      selectedType,
      selectedOption,
      selectedCategories,
      selectedChallenges,
      vision,
      selectedS,
      selectedQ,
      location,
    };
    localStorage.setItem("registrationData", JSON.stringify(dataToSave));
    setIsSaveModalOpen(true); // Open Save modal
  };
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
  const [loginEmail, setLoginEmail] = useState(""); // Email input state
  const [loginPassword, setLoginPassword] = useState(""); // Password input state
  const [loginError, setLoginError] = useState(null); // Login error state
  // Handle Login from "Edit" Pop-up
  const handleLogin = async () => {
    try {
      setLoading(true);
      setLoginError(null); // Clear any previous errors

      // Attempt to sign in with email and password
      const userCredential = await signInWithEmailAndPassword(auth, loginEmail, loginPassword);
      const userDoc = await getDoc(doc(db, "registrations", userCredential.user.uid));

      if (userDoc.exists()) {
        const userData = userDoc.data();
        setFormData(userData.personalInfo || {}); // Populate form with user data
        setOrgFormData(userData.organizationInfo || {}); // Populate organization form data
        setDropdownSelections(userData.dropdownSelections || {});
        setReportSelections(userData.reportSelections || {});
        setSelectedLanguage(userData.language || null);
        setLandType1(userData.background?.landType1 || "");
        setLandType2(userData.background?.landType2 || "");
        setErfNumber(userData.background?.erfNumber || "");
        setSelectedSkills(userData.profingSkills || []);
        setSelectedMembership(userData.membership || "");
        setSelectedExperience(userData.groupExperience || []);
        setFocusSelected(userData.sectionD?.focusSelected || []);
        setSelectedType(userData.sectionD?.selectedType || "");
        setSelectedOption(userData.sectionD?.selectedOption || "Maize");
        setSelectedCategories(userData.sectionD?.selectedCategories || []);
        setSelectedChallenges(userData.industry?.selectedChallenges || []);
        setVision(userData.industry?.vision || "");
        setSelectedS(userData.setaQualification?.selectedS || "Agri");
        setSelectedQ(userData.setaQualification?.selectedQ || "Business Administration");
        setLocation(userData.location || null);

        setIsLoggedIn(true); // Mark user as logged in
        setIsEditModalOpen(false); // Close the modal upon successful login
        console.log("Login successful! User data loaded.");
      } else {
        console.error("No such document exists for the logged-in user.");
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);

      // Provide feedback for login failure
      if (error.code === "auth/user-not-found") {
        setLoginError("No account found with this email.");
      } else if (error.code === "auth/wrong-password") {
        setLoginError("Incorrect password. Please try again.");
      } else {
        setLoginError("An error occurred during login. Please try again later.");
      }

      console.error("Login failed:", error);
    }
  };
  // Close Save Modal
  const closeSaveModal = () => {
    setIsSaveModalOpen(false);
  };

  // Close Registration Modal
  const closeRegisterModal = () => {
    setIsRegisterModalOpen(false);
  };
  const [certificatesUrls, setCertificatesUrls] = useState([]);
  const [idDocumentUrl, setIdDocumentUrl] = useState("");
  const [dropdownSelections, setDropdownSelections] = useState({
    user_type: dropdownItems.FACILITATOR[0],
    user_purpose: dropdownItems.PURPOSE[0]
  });
  const [landType1, setLandType1] = useState("");
  const [landType2, setLandType2] = useState("");
  const [erfNumber, setErfNumber] = useState("");
  // ... other state
  const [selectedS, setSelectedS] = useState("Agri"); // initial SETA
  const [selectedQ, setSelectedQ] = useState("Business Administration"); // initial Qualification
  const [showDropdownError, setShowDropdownError] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

  const handleDropdownSave = (data) => {
    // Log all values from the dropdowns in registration page
    console.log(' SETA and Qualification:', data);
    // data = { SETA: "Bank", QUALIFICATIONS: "IT Technical Support" }
  };
  const handleBackgroundSave = (data) => {
    // Log all background info
    console.log('Background Info:', data);
  };
  const handleDropdownChange = (type, value) => {
    // Map dropdown type to your desired object keys
    const keyMap = {
      FACILITATOR: 'user_type',
      PURPOSE: 'user_purpose'
    };

    const mappedKey = keyMap[type];

    setDropdownSelections(prev => ({
      ...prev,
      [mappedKey]: value
    }));

    // Log only the mapped keys and latest values
    console.log({
      user_type: type === "FACILITATOR" ? value : dropdownSelections.user_type,
      user_purpose: type === "PURPOSE" ? value : dropdownSelections.user_purpose
    });
  };
  const [selectedChallenges, setSelectedChallenges] = useState([]);
  const [vision, setVision] = useState("");

  const handleIndustrySave = (data) => {
    console.log('Industry Activity Survey:', data);
    // {
    //   cooperativeName: ...,
    //   section: ...,
    //   vision: ...,
    //   selectedChallenges: [...]
    // }
  };
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [focusSelected, setFocusSelected] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [showBackgroundError, setShowBackgroundError] = useState(false);
  // When the user clicks Register
  // Handle Registration
  const handleRegister = async () => {
    if (isLoggedIn) {
      // If the user is logged in, update their details instead of registering
      console.log("User is already logged in. Updating user details...");
      try {
        // Update user details in Firestore
        await updateUserDetails(); // Function to update user data
        setRegistrationError(null); // Clear any previous errors
        setRegistrationNumber("Your details have been updated successfully!"); // Show update confirmation
        setIsModalOpen(true); // Show success modal
      } catch (error) {
        console.error("Error updating user details:", error);
        setRegistrationError("An error occurred while updating your details. Please try again.");
      }
      return;
    }

    // New user registration logic
    try {
      setLoading(true);
      setRegistrationError(null);

      // Check if the email already exists in Firebase
      const signInMethods = await fetchSignInMethodsForEmail(auth, formData.email);
      if (signInMethods.length > 0) {
        setRegistrationError("This email is already registered. Please log in instead.");
        setLoading(false);
        return;
      }

      // Register new user
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      const uid = userCredential.user.uid;

      // Generate Registration Number
      const regNumber = generateRegistrationNumber();

      // Save user data to Firestore
      await saveUserData(uid, regNumber);

      setLoading(false);
      setRegistrationNumber(regNumber); // Show the registration number to the user
      console.log("Registration successful!");
      setIsModalOpen(true); // Show success modal
    } catch (error) {
      setLoading(false);

      // Handle Firebase errors
      if (error.code === "auth/email-already-in-use") {
        setRegistrationError("Error - Email already in use / taken");
      } else if (error.code === "auth/weak-password") {
        setRegistrationError("Error - Password is too weak");
      } else if (error.code === "auth/invalid-email") {
        setRegistrationError("Error - Invalid email address");
      } else {
        setRegistrationError("An error occurred during registration.");
      }

      console.error("Registration error:", error);
    }
  };

  const handleFocusSave = (data) => {
    console.log("Areas of Focus:", data);
    // {
    //   cooperativeName: ...,
    //   typeOfFocus: ...,
    //   selectedAreas: [...],
    //   selectedDisabilityType: ...
    // }
  };
  // Save User Data to Firestore
  const saveUserData = async (uid, regNumber) => {
    const userPayload = {
      personalInfo: { ...formData },
      organizationInfo: { ...orgFormData },
      dropdownSelections,
      reportSelections,
      language: selectedLanguage,
      background: { landType1, landType2, erfNumber },
      profingSkills: selectedSkills,
      membership: selectedMembership,
      groupExperience: selectedExperience,
      sectionD: { focusSelected, selectedType, selectedOption, selectedCategories },
      industry: { selectedChallenges, vision },
      setaQualification: { selectedS, selectedQ },
      location,
      registrationNumber: regNumber,
      createdAt: new Date().toISOString(),
    };
    await setDoc(doc(db, "registrations", uid), userPayload);
    console.log("User data saved to Firestore:", userPayload);
  };
  // Update Existing User Data
  const updateUserDetails = async () => {
    const user = auth.currentUser; // Get the currently logged-in user
    if (user) {
      const userDocRef = doc(db, "registrations", user.uid); // Reference to the user's document in Firestore
      const updatedPayload = {
        personalInfo: { ...formData },
        organizationInfo: { ...orgFormData },
        dropdownSelections,
        reportSelections,
        language: selectedLanguage,
        background: { landType1, landType2, erfNumber },
        profingSkills: selectedSkills,
        membership: selectedMembership,
        groupExperience: selectedExperience,
        sectionD: { focusSelected, selectedType, selectedOption, selectedCategories },
        industry: { selectedChallenges, vision },
        setaQualification: { selectedS, selectedQ },
        location,
        updatedAt: new Date().toISOString(), // Add a timestamp for updates
      };

      // Save updated data to Firestore
      await setDoc(userDocRef, updatedPayload, { merge: true }); // Merge updated data with existing document
      console.log("User details updated successfully.");
    } else {
      console.error("No logged-in user found.");
      throw new Error("User not logged in.");
    }
  };
  const [selectedOption, setSelectedOption] = useState("Maize");
  const [selectedCategories, setSelectedCategories] = useState([]);

  const handleSectionDSave = (data) => {
    // data = { typeOfOrganization: ..., categories: [...] }
    console.log("Section D Industry Interest:", data);
  };

  const handleGroupExperienceSave = (data) => {
    console.log('Group Experience:', data);
    // Example:
    // {
    //   cooperativeName: 'YourCooperativeName',
    //   typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
    //   selectedExperience: [...]
    // }
  };

  // ProfingSkils state
  const [agreed, setAgreed] = useState(false);
  const [showAgreementError, setShowAgreementError] = useState(false); // State for showing error
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedMembership, setSelectedMembership] = useState(""); // e.g. "AFASA" or "Others"
  const handleMembershipSave = (value) => {
    // Example: add more keys if needed
    console.log("Membership/Affiliation Selected:", value);
  };
  const handleProfingSkillsSave = (skills) => {
    // Example: log with cooperative name and type if you have them
    const data = {
      PersonalSkillsTrainingandQualifications: 'PersonalSkillsTrainingandQualifications', // replace/fetch as needed
      typeOfProfingSkill: 'Personal Skills Training and Qualifications',
      selectedSkills: skills,
    };
    console.log('Profing Skills:', data);
  };
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Add your main save handler (use the same function as your Register button)
  const [savedLocation, setSavedLocation] = useState(null);

  // Call this when Register button is clicked
  const handleRegisterSave = () => {
    const cooperative = {
      // ...other registration fields,
      location: savedLocation
    };
    console.log("location:", cooperative);
    // ...show modal, etc.
  };

  const [location, setLocation] = useState(null);

  // This gets called when "Save Location" is clicked inside LocationPicker
  const [locationCountry, setLocationCountry] = useState("");

  const handleSaveLocation = (country) => {
    setLocationCountry(country);
    console.log("User selected country:", country);
  };


  const [showUnits, setShowUnits] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState("Hectare");
  const [landSize, setLandSize] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');

  const [selected3, setSelected3] = useState('Individual');

  const handleCopy = () => {
    navigator.clipboard.writeText('ZA25-582-9511');
    setCopyMessage('Copied!'); // Set the "Copied!" message

    // Hide the message after 2 seconds
    setTimeout(() => {
      setCopyMessage('');
    }, 2000);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const units = ["Hectare", "Acre", "Square Meter"];

  const handleUnitSelect = (unit) => {
    setSelectedUnit(unit);
    setShowUnits(false);
  };

  // Report dropdown state
  const [reportSelections, setReportSelections] = useState(initialReportSelections);

  // Handler for report dropdowns
  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const updated = { ...prev, [type]: value };
      // Log with readable keys (convert keys if you want)
      console.log({
        country: updated.COUNTRY,
        region: updated.REGION,
        municipality: updated.MUNICIPALITY,
        type: updated.TYPE,
        value_chain: updated["VALUE CHAIN"],
        project: updated.PROJECT
      });
      return updated;
    });
  };
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const handleLanguageChange = (lang) => {
    setSelectedLanguage(lang);
    console.log("Selected language:", lang);
  };
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    dateOfBirth: "",
    typeOfId: "",
    idNumber: "",
    mobile: "",
    email: "",
    password: "",
    whatsapp: "",
    physicalAddress: "",
    postalCode: "",
  });
  const [race, setRace] = useState("");
  const [gender, setGender] = useState("");
  const [disability, setDisability] = useState("");

  // Log all values here when Save is clicked in PersonalInfoForm
  const handlePersonalInfoSave = (data) => {
    console.log('Personal Info Form Data:', data);
  };

  const [orgFormData, setOrgFormData] = useState({
    cooperativeName: "",
    registrationNumber: "",
    members: "",
    mobileNumber: "",
    physicalAddress: "",
    chairFirstName: "",
    chairSurname: "",
    secretaryFirstName: "",
    secretarySurname: "",
    email: "",
    password: "",
  });
  const [orgType, setOrgType] = useState("COOPERATIVE 1");

  const handleOrgSave = (data) => {
    // This logs all org fields to the console
    console.log('Organization Form Data:', data);
  };

  const [loading, setLoading] = useState(false);
  const [progressMsg, setProgressMsg] = useState("");
  const [registrationError, setRegistrationError] = useState(null);
  const [registrationNumber, setRegistrationNumber] = useState("");

  const onHandleSave = async () => {
    setLoading(true);
    setProgressMsg("Saving...");
    setRegistrationError(null);

    try {
      let uid;

      if (isEditModalOpen) {
        // If the user is editing, use the existing UID from the logged-in user
        const user = auth.currentUser;
        if (!user) {
          throw new Error("User not logged in.");
        }
        uid = user.uid;
      } else {
        // Create Firebase Auth user (for new registration)
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          formData.email,
          formData.password
        );
        uid = userCredential.user.uid;
        console.log("Firebase Auth user created:", userCredential.user);
      }

      // Generate Registration Number
      const regNumber = generateRegistrationNumber();

      // Build full data payload
      const registrationPayload = {
        userType: dropdownSelections.user_type,
        userPurpose: dropdownSelections.user_purpose,
        reportSelections,
        language: selectedLanguage,
        personalInfo: {
          ...formData,
          race, gender, disability
        },
        organizationInfo: {
          ...orgFormData,
          orgType,
          certificates: certificatesUrls,
          idDocument: idDocumentUrl,
        },
        background: { landType1, landType2, erfNumber },
        profingSkills: selectedSkills,
        membership: selectedMembership,
        groupExperience: selectedExperience,
        sectionD: { focusSelected, selectedType, selectedOption, selectedCategories },
        industry: { selectedChallenges, vision },
        setaQualification: { selectedS, selectedQ },
        location,
        registrationNumber: regNumber,
        createdAt: new Date().toISOString(),
        uid,
      };

      console.log("Registration data to save:", registrationPayload);

      // Save to Firestore
      await setDoc(doc(db, "registrations", uid), registrationPayload);

      // Send email (for new registrations only)
      if (!isEditModalOpen) {
        await sendRegistrationEmail({
          user_name: formData.firstName + " " + formData.surname,
          registration_number: regNumber,
          user_email: formData.email,
          user_type: dropdownSelections.user_type,
          name: formData.firstName + " " + formData.surname,
          email: formData.email,
        });
        console.log("Registration email sent to:", formData.email, "with registration number:", regNumber);
      }

      // Finish
      setLoading(false);
      setRegistrationNumber(regNumber);
      setIsModalOpen(true);
    } catch (e) {
      setLoading(false);

      // Handle errors specifically for new registrations only
      if (!isEditModalOpen) { // <-- Ensure this only applies to new users
        let customErrorMessage = "An error occurred.";
        if (e.code === "auth/email-already-in-use") {
          customErrorMessage = "Error - Email already in use / taken";
        } else if (e.code === "auth/weak-password") {
          customErrorMessage = "Error - Password is too weak";
        } else if (e.code === "auth/invalid-email") {
          customErrorMessage = "Error - Invalid email address";
        }
        setRegistrationError(customErrorMessage);
      } else {
        console.error("Error during edit:", e);
      }
    }
  };
  // Load saved data from local storage on component mount
  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("registrationData"));
    if (savedData) {
      setFormData(savedData.formData || {});
      setOrgFormData(savedData.orgFormData || {});
      setDropdownSelections(savedData.dropdownSelections || {});
      setReportSelections(savedData.reportSelections || initialReportSelections);
      setSelectedLanguage(savedData.selectedLanguage || null);
      setLandType1(savedData.landType1 || "");
      setLandType2(savedData.landType2 || "");
      setErfNumber(savedData.erfNumber || "");
      setSelectedSkills(savedData.selectedSkills || []);
      setSelectedMembership(savedData.selectedMembership || "");
      setSelectedExperience(savedData.selectedExperience || []);
      setFocusSelected(savedData.focusSelected || []);
      setSelectedType(savedData.selectedType || "");
      setSelectedOption(savedData.selectedOption || "Maize");
      setSelectedCategories(savedData.selectedCategories || []);
      setSelectedChallenges(savedData.selectedChallenges || []);
      setVision(savedData.vision || "");
      setSelectedS(savedData.selectedS || "Agri");
      setSelectedQ(savedData.selectedQ || "Business Administration");
      setLocation(savedData.location || null);
    }
  }, []);

  // Updated handleRegisterClick to reset the error state
  const handleRegisterClick = () => {
    if (!agreed) {
      setShowAgreementError(true); // Show error if not agreed
      return;
    }
    setShowAgreementError(false);

    // Clear any previous errors before attempting registration
    setRegistrationError(null);

    onHandleSave(); // Proceed with registration logic
  };
  // Example: Reset error when typing in the email or password fields
  const handleFormInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    setRegistrationError(null); // Clear the error when the user starts typing
  };


  return (
    <div>
      <div className='md:px-28 px-4'>
        <div className=" w-full  mx-auto md:pt-1 pt-2">
          <h2 className="text-left font-bold text-[14px] text-[#03897B] md:text-[36px]">
            REGISTRATION
          </h2>
          {/* Labels directly above the bar */}
          <div>
            <div className="relative w-full mx-auto h-[40px] md:mb-4 md:mt-3 mb-0">
              <span
                className={`absolute top-0 left-[25%] sm:left-[25%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${selected3 === 'Individual' ? 'text-black' : 'text-black'
                  }`}
                onClick={() => setSelected3('Individual')}
              >
                Individual
              </span>

              <a href='/RegisterOrganization'>
                <span
                  className={`absolute top-0 left-[75%] sm:left-[75%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${selected3 === 'Organization' ? 'text-black' : 'text-black'
                    }`}
                  onClick={() => setSelected3('Organization')}
                >
                  Organization
                </span>
              </a>
            </div>

            {/* Toggle Bar */}
            <div className="w-full md:h-[10px] h-[4px] bg-[#D9D9D9] flex rounded-[10px] overflow-hidden md:mt-0 mb-2 -mt-5 md:mb-6 mx-auto">
              {/* Individual Side */}
              <div
                className="w-1/2 h-full cursor-pointer relative"
                onClick={() => setSelected3('Individual')}
              >
                <div
                  className={`absolute inset-0 transition-all duration-300 ${selected3 === 'Individual' ? 'bg-[#03897B]' : 'bg-[#D9D9D9]'
                    } rounded-[10px]`}
                ></div>
              </div>

              {/* Organization Side */}
              <a href='/RegisterOrganization'>
                <div
                  className="w-1/2 h-full cursor-pointer relative"
                  onClick={() => setSelected3('Organization')}
                >
                  <div
                    className={`absolute inset-0 transition-all duration-300 ${selected3 === 'Organization' ? 'bg-[#03897B]' : 'bg-[#D9D9D9]'
                      } rounded-[10px]`}
                  ></div>
                </div>
              </a>
            </div>
          </div>

          <div className="flex justify-between items-center w-full ">
            {/* LEFT SIDE - HEADING */}
            <div>

              <div className="flex-1 md:mt-2">
                <div>
                  <div className="flex md:flex-row items-start md:gap-4 gap-1 ">
                    <a href='/SMEChallenges'>

                      <div className="md:w-[310px] w-[80px] md:max-w-[310px]">
                        <button className="w-full h-[20px] md:h-[60px] text-left rounded-[5px] px-2 md:px-4 bg-[#E7EBEB] border-b-[4px] border-[#919291] text-[5px] md:text-[20px] font-bold">
                          Entrepreneurs challenges
                        </button>
                        <p className='text-[4px] md:text-[16px] leading-tight font-normal mt-1'>
                          Click to read entrepreneurs <br /> challenges
                        </p>
                      </div>
                    </a>

                    <div className="md:w-full w-[80px] md:max-w-[290px]">
                      <a href='/BenefitsOfRegistring'>
                        <button className="w-full h-[20px] md:h-[60px] text-left px-1 md:px-4 rounded-[5px] bg-[#E7EBEB] border-b-[4px] border-[#919291] text-[5px] md:text-[20px] font-bold">
                          Benefits of registration
                        </button>
                      </a>
                      <p className='text-[4px] md:text-[16px] font-normal mt-1'>
                        Click to read benefits of registration
                        <br />
                        <span className="text-transparent">sss</span>
                      </p>
                    </div>

                  </div>
                </div>
              </div>
            </div>


            {/* RIGHT SIDE - DROPDOWNS */}
            <div className="flex gap-4 flex-wrap justify-end md:-mt-5 ">
              {keys.map((type, index) => {
                const customLabels = {
                  Crop: "Crop Report",
                  Livestock: "Livestock Report",
                  Type: "Type of Report",
                };

                const displayLabel = customLabels[type] || type;
                const isProjectDropdown = index === keys.length - 1;

                return (
                  <div key={type} className="w-auto">
                    <Dropdown
                      label={displayLabel}
                      items={dropdownItems[type]}
                      type={type}
                      isProjectDropdown={isProjectDropdown}
                      onChange={handleDropdownChange}
                    />
                  </div>
                );
              })}
            </div>

          </div>
          <ReportsSection values={reportSelections} onChange={handleReportDropdownChange} />
          <LanguageSelector onChange={handleLanguageChange} />
          {/* 
          <OfficialNews /> */}
        </div>
        <PersonalInfoForm
          formData={formData}
          onFormDataChange={setFormData}
          race={race}
          onRaceChange={setRace}
          gender={gender}
          onGenderChange={setGender}
          disability={disability}
          onDisabilityChange={setDisability}
          onSave={handlePersonalInfoSave}
        />
<OrganizationForm
  formData={orgFormData}
  onFormDataChange={setOrgFormData}
  selectedOption={orgType}
  onOptionChange={setOrgType}
  onCertificatesUrlChange={setCertificatesUrls} // Receive certificate URLs
  onIdUrlChange={setIdDocumentUrl}             // Receive ID document URL
  onSave={setOrgFormData}
/>
        <BackgroundInfoSection
          languages={languages}
          languages1={languages1}
          setLandSizes={setLandSizes} // Pass it as a prop
          selected={landType1}
          setSelected={setLandType1}
          selected1={landType2}
          setSelected1={setLandType2}
          erfNumber={erfNumber}
          showError={showBackgroundError}
          setErfNumber={setErfNumber}
          onSave={handleBackgroundSave}
        />
        <div>
          <div className='xl:w-[168vh] lg:w-[120vh] md:w-[100vh] max-w-none'>
            <ProfingSkils
              selectedSkills={selectedSkills}
              setSelectedSkills={setSelectedSkills}
              onSave={handleProfingSkillsSave}
            />
          </div>
        </div>

        <div >

          <Dropdown1
            selectedS={selectedS}
            setSelectedS={setSelectedS}
            selectedQ={selectedQ}
            setSelectedQ={setSelectedQ}
            onSave={handleDropdownSave}
          />

          <MembershipSection
            selectedMembership={selectedMembership}
            setSelectedMembership={setSelectedMembership}
            onSave={handleMembershipSave}
          />
          <GroupExperience
            selectedExperience={selectedExperience}
            setSelectedExperience={setSelectedExperience}
            onSave={handleGroupExperienceSave}
          />
          <SectionDnew
            selected={focusSelected}
            setSelected={setFocusSelected}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            onSave={handleFocusSave}
          />
          <SectionD
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            onSave={handleSectionDSave}
          />
          <IndustrySection
            selected={selectedChallenges}
            setSelected={setSelectedChallenges}
            vision={vision}
            setVision={setVision}
            onSave={handleIndustrySave}
          />

          {/* Save button */}

          <div>
            {/* Save button */}


            <SaveButtonWithModal />
          </div>
          {/* Location Section */}
          <div className="md:-mt-3 flex items-center space-x-3">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png" alt=".." className="md:w-[37px] w-[17px] h-[17px] md:h-[37px]" />
            <h1 className="md:text-[36px] text-[10px] font-bold">Set Location</h1>
          </div>
          <div className="h-auto w-full rounded-md mt-3 md:pb-4 pb-2">
            <LocationPicker onSaveLocation={handleSaveLocation} />
            <div >
              {/* Checkbox Box */}
              <div className="flex flex-col justify-end  ">


                {/* Buttons */}
                <div className="flex md:gap-4 gap-1  justify-end mt-2">
                  {/* Edit Button */}
                  <div>
                    <button
                      className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] md:px-4 px-2 text-[6px] font-bold rounded-[10px]"
                      onClick={() => setIsEditModalOpen(true)}
                    >
                      <span>EDIT</span>
                      <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                        alt="Edit Icon"
                        className="md:w-[35px] h-2  md:h-[38px] w-2"
                      />
                    </button>

                    <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
                      Edit registration form
                    </p>
                    <Modal
                      isOpen={isEditModalOpen}
                      onRequestClose={() => setIsEditModalOpen(false)}
                      contentLabel="Login to Edit"
                      className="modal-content"
                      overlayClassName="modal-overlay"
                    >
                      {/* Close Button */}
                      <button
                        onClick={() => setIsEditModalOpen(false)}
                        className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
                        aria-label="Close"
                      >
                        &times;
                      </button>

                      <div className="md:p-4 p-2">
                        <h2 className="text-center md:text-[40px] font-extrabold mb-4">Login</h2>
                        <div>
                          <label className="block md:text-[28px] text-[8px] font-medium">Email</label>
                          <input
                            type="email"
                            value={loginEmail}
                            placeholder="Enter email"
                            onChange={(e) => setLoginEmail(e.target.value)}
                            className="w-full h-[30px] md:h-[71px] p-1 md:p-2 pl-3 md:pl-4 text-[8px] md:text-[32px] border rounded-[5px] text-black bg-[#E7EBEB] border-[#E7EBEB] placeholder:text-[#979797]"
                          />
                        </div>
                        <div className="mt-4">
                          <label className="block md:text-[28px] text-[8px] font-medium">Password</label>
                          <input
                            type="password"
                            value={loginPassword}
                            placeholder="Enter password"
                            onChange={(e) => setLoginPassword(e.target.value)}
                            className="w-full h-[30px] md:h-[71px] p-1 md:p-2 pl-3 md:pl-4 text-[8px] md:text-[32px] border rounded-[5px] text-black bg-[#E7EBEB] border-[#E7EBEB] placeholder:text-[#979797]"
                          />
                        </div>
                        {loginError && <p className="text-red-500 text-sm mt-2">{loginError}</p>}
                        {isLoggedIn && <p className="text-green-500 text-sm mt-2">Login successful!</p>}
                        <div className="mt-6 flex justify-between md:gap-8">
                          <button
                            onClick={() => setIsEditModalOpen(false)}
                            className="bg-gray-300 text-black md:text-[20px] w-full px-4 md:py-4 py-2 rounded-md"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleLogin}
                            className="bg-teal-700 md:text-[20px] text-white w-full px-4 md:py-4 rounded-md"
                          >
                            {loading ? "Logging in..." : "Login"}
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>


                  {/* Save Button */}
                  <div>
                    {/* Save Button */}
                    <div>
                      <button
                        className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] px-4"
                        onClick={handleSaveClick}
                      >
                        <span>SAVE</span>
                        <img
                          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
                          alt="Save Icon"
                          className="md:w-[35px] h-2  md:h-[38px] w-2 "
                        />
                      </button>
                      <p className="md:text-[14px] text-[6px] md:mt-4 mt-1 font-normal md:px-1">
                        Save registration
                      </p>
                    </div>


                    {/* Save Confirmation Modal */}
                    <Modal
                      isOpen={isSaveModalOpen}
                      onRequestClose={closeSaveModal}
                      contentLabel="Save Successful"
                      className="modal-content"
                      overlayClassName="modal-overlay"
                    >
                      <button
                        onClick={closeSaveModal}
                        className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                        aria-label="Close"
                      >
                        &times;
                      </button>
                      <div>
                        <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
                          <div className="flex flex-col items-center justify-center text-center h-full w-full">
                            <div className="relative mb-4 w-full flex justify-center items-center">
                              <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                alt="Success"
                                className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                              />
                              <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                Save Successful
                              </div>
                            </div>
                            <p className="text-black text-[10px] md:text-[32px] mb-2">
                              The registration form has been successfully saved.
                            </p>
                            <button
                              onClick={closeSaveModal}
                              className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </Modal>

                    {/* Registration Confirmation Modal */}
                    <Modal
                      isOpen={isRegisterModalOpen}
                      onRequestClose={closeRegisterModal}
                      contentLabel="Registration Successful"
                      className="modal-content"
                      overlayClassName="modal-overlay"
                    >
                      <button
                        onClick={closeRegisterModal}
                        className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                        aria-label="Close"
                      >
                        &times;
                      </button>
                      <div>
                        <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
                          <div className="flex flex-col items-center justify-center text-center h-full w-full">
                            <div className="relative mb-4 w-full flex justify-center items-center">
                              <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                alt="Success"
                                className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                              />
                              <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                Registration Successful
                              </div>
                            </div>
                            <p className="text-black text-[10px] md:text-[32px] mb-2">
                              Thank you for registering with Ad-Luck
                            </p>
                            <p className="text-black text-[10px] md:text-[32px] mb-4">
                              Your unique registration number is:
                            </p>
                            <div className="flex items-center justify-between w-full mb-6 mt-8 px-4">
                              <div className="flex-1 flex justify-center">
                                <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                                  {registrationNumber}
                                </span>
                              </div>
                              <button
                                onClick={() => {
                                  navigator.clipboard.writeText(registrationNumber);
                                  setCopyMessage("Copied!");
                                  setTimeout(() => setCopyMessage(""), 2000);
                                }}
                                className="bg-[#F38323] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]"
                              >
                                Copy
                              </button>
                            </div>
                            {copyMessage && (
                              <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                {copyMessage}
                              </div>
                            )}
                            <a href="/">
                              <button
                                onClick={closeRegisterModal}
                                className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                              >
                                Continue to Home
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
              <div className='flex gap-4 items-center mt-5'>
                <div
                  className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                  onClick={() => {
                    setAgreed((prev) => !prev);
                    setShowAgreementError(false); // Clear error when checkbox is clicked
                  }}
                  tabIndex={0}
                  aria-pressed={agreed}
                  aria-label="Confirm terms and conditions"
                >
                  {/* Black or Green Check Round Fill SVG */}
                  {agreed ? (
                    // GREEN CHECK ROUND FILL
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="27" cy="27" r="27" fill="#01897B" />
                      <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    // BLACK CHECK ROUND FILL
                    <svg
                      width="54"
                      height="54"
                      viewBox="0 0 54 54"
                      fill="none"
                      className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="27" cy="27" r="27" fill="#222" />
                      <path d="M39 21L24.75 35L15 25.4545" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                </div>
                <p className="md:text-[20px] text-[6px]">
                  By ticking I confirm that I agree with the{" "}
                  <a className="underline hover:text-teal-600" href='/TermsAndCondition'>Terms and conditions</a>,<a href='/DataPolicy'>Data </a>and{" "}
                  <a className="underline hover:text-teal-600" href='/PrivacyPolicy'>Privacy policy</a>.
                </p>
              </div>

              <p className={`md:text-[14px] text-[10px] ${agreed ? "text-white hidden " : " text-red-600 cursor-not-allowed"
                }`}>
                Please agree to the terms and conditions before proceeding.
              </p>

              {/* Text */}

            </div>
          </div>


          {/* Register Button */}
          {/* Register Button */}
          <button
            onClick={handleRegister} // Call the handleRegister function here
            disabled={loading} // Only disable for loading
            className={`w-full flex justify-center md:text-[28px] text-[8px] font-bold items-center md:mt-0 border-b-[3px] md:py-1 py-1 text-center md:h-[74px] h-[20px] ${agreed ? "bg-[#03897B] text-white border-[#FDBD26]" : "bg-gray-400 text-gray-200 border-gray-300 cursor-not-allowed"
              }`}
          >
            {loading ? progressMsg || "Saving..." : "Register"}
          </button>
          {registrationError && <div style={{ color: "red" }}>{registrationError}</div>}
          <Modal
            isOpen={isModalOpen}
            onRequestClose={() => setIsModalOpen(false)}
            contentLabel="Registration Successful"
            className="modal-content"
            overlayClassName="modal-overlay"
          >
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
              aria-label="Close"
            >
              &times;
            </button>
            <div>
              <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[450px]">
                <div className="flex flex-col items-center justify-center text-center h-full w-full">
                  <div className="relative mb-4 w-full flex justify-center items-center">
                    <img
                      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                      alt="Success"
                      className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                    />
                    <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                      {isLoggedIn ? "Update Successful" : "Registration Successful"}
                    </div>
                  </div>
                  <p className="text-black text-[10px] md:text-[32px] mb-2">
                    {isLoggedIn
                      ? "Your details have been updated successfully!"
                      : `Thank you for registering with Ad-Luck`}
                  </p>
                  {!isLoggedIn && (
                    <p className="text-black text-[10px] md:text-[32px] mb-4">
                      Your unique registration number is:
                    </p>
                  )}
                  {!isLoggedIn && (
                    <div className="flex items-center justify-between w-full mb-6 md:mt-8 px-4">
                      <div className="flex-1 flex justify-center">
                        <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                          {registrationNumber}
                        </span>
                      </div>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(registrationNumber);
                          setCopyMessage("Copied!");
                          setTimeout(() => setCopyMessage(""), 2000);
                        }}
                        className="bg-[#F38323] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]"
                      >
                        Copy
                      </button>
                    </div>
                  )}
                  {copyMessage && (
                    <div className="text-black text-[14px] md:text-[18px] font-semibold">
                      {copyMessage}
                    </div>
                  )}
                  <a href="/">
                    <button
                      onClick={() => setIsModalOpen(false)}
                      className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold"
                    >
                      Continue to Home
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </Modal>
          {/* App Download Section */}
          <div className="md:h-4"></div>
          <h1 className="md:text-[36px] text-[10px] font-bold md:mt-8 mt-1 mb-4">Download App</h1>
          <div className="flex flex-wrap md:justify-between gap-8 md:gap-0 md:max-w-2xl items-center">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png" className="h-[25px] md:h-[76px]" alt="App Store" />
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png" className="h-[25px] md:h-[76px]" alt="Google Play" />
          </div>
          <div className="md:h-4"></div>

        </div>
      </div>




    </div>
  );
};

export default RegisterAsFarm;